import { cn } from "tools/ui";

function ColForm(props) {
  let colspan = "col-span-2 lg:col-span-1";
  if (props.colspan) {
    // FIXME
    // rows = field.size[0];
    console.log("No use este atributo colspan, va quedar en desuso!!!!");
    console.log("A cambio use el atributo colSpan en el ctxView");
    colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";
  }
  if (props.colSpan) {
    colspan = "md:col-span-2 lg:col-span-2 xl:col-span-2";
  }
  return (
    <div id="col-form" className={cn("mt-1 mb-2 w-full", colspan)}>
      {props.children}
    </div>
  );
}

export default ColForm;
